export default "__VITE_ASSET__CvjVZDnr__"